import React from 'react';

// Utils
import { useFormik } from 'formik';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import resetPasswordSchema from '../../../validations/resetPasswordSchema';

// Services
import useAuthService from '../../../services/authService';

// Components
import AuthTemplate from '../../layout/AuthTemplate/AuthTemplate';
import FlashMessage from '../../molecules/FlashMessage/FlashMessage';
import InputField from '../../atoms/InputField/InputField';
import Button from '../../atoms/Button/Button';

function ResetPasswordForm() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const { postFinalizePasswordReset } = useAuthService();

  const {
    mutate: postFinalizeMutate, isLoading, isSuccess, isError,
  } = useMutation(postFinalizePasswordReset);

  const formik = useFormik({
    initialValues: {
      newPassword: '',
      confirmPassword: '',
    },
    onSubmit: (values) => {
      postFinalizeMutate({
        password: values.newPassword,
        adminType: searchParams?.get('type'),
        token: searchParams?.get('token'),
      });
    },
    validationSchema: resetPasswordSchema,
  });

  const getInput = (name) => (
    <div className="m-b-15">
      <InputField
        type="password"
        id={`reset_${name}`}
        name={name}
        value={formik.values[name]}
        label={t(`login.reset.${name}`)}
        formik={{
          handleChange: formik.handleChange,
          handleBlur: formik.handleBlur,
        }}
        error={formik.errors?.[name] && formik.touched?.[name] ? formik.errors[name] : null}
        isRequired
      />
    </div>
  );

  return (
    <AuthTemplate title={t('login.login')} showBackButton>
      {isError ? (
        <FlashMessage
          message={t('code_errors.generic')}
          color="error"
          className="m-b-20"
        />
      ) : null}

      {isSuccess ? (
        <FlashMessage
          message={t('login.reset.success', { email: formik.values.email })}
          color="success"
          className="m-b-20"
        />
      ) : null}

      <h2 className="fs-20 fw-500 m-b-20">{t('login.reset.title')}</h2>

      <form onSubmit={formik.handleSubmit} className="m-t-20">
        {getInput('newPassword')}
        {getInput('confirmPassword')}

        <div className="m-t-20">
          <Button submitType isLoading={isLoading}>
            {t('login.reset.submit')}
          </Button>
        </div>
      </form>
    </AuthTemplate>
  );
}

export default ResetPasswordForm;
